<template>
  <div class="container">
    <div class="vlogin">
      <div class="vlogin_container">
        <!-- <img class="vlogin_container_logo" src="http://feiran-unionfit.oss-cn-beijing.aliyuncs.com/2026/03/taFOj_wv5oFwYrKHUzoXt.png" /> -->
        <img class="vlogin_container_img" src="../../assets/images/base/login_container_bg.png" />
        <div class="vlogin_container_con">
          <div class="vlogin_container_title">百动</div>
          <div class="vlogin_container_tips"></div>
          <div class="login_item">
            <van-row>
              <van-col span="20">
                <div class="login_item_date">
                  <input type="text" placeholder="请输入姓名" v-model="param.name">
                  
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="login_item">
            <van-row>
              <van-col span="20">
                <div class="login_item_date">
                  <input type="tel" maxlength="11" placeholder="输入手机号" v-model="param.mobile">
                  
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="login_item_submit">
            <div class="login_item_submit_bg"></div>
            <div class="login_item_submit_txt" @click.stop.prevent="doLogin">{{login_button_txt}}</div>
          </div>
          <div class="form__note" style="visibility:visible">{{loginNote}}</div>
          <div class="login_item_tip">
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    isPhone
  } from "../../lib/utils.js"
  export default {
    data() {
      return {
        codeTxt: "获取验证码",
        param: {
          mobile: "",
          name: ""
        },
        loginNote: "",
        clearFlag: false,
        login_button_txt: '报名'
      }
    },
    created() {

      this.$loading.close()
      this.getOpenId();

    },
    mounted() {
      // 如果支持 popstate 一般移动端都支持了
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新
        window.addEventListener('popstate', this.backChange, false);//false阻止默认事件
      }

    },
    watch: {

    },
    methods: {
      doLogin() {
        this.$loading('正在提交')
        var $this = this
        if (!isPhone(this.param.mobile)) {
          this.loginNote = "请输入正确手机号"
          $this.$loading.close()
          return;
        } else {
          this.loginNote = "";
        }
        if(this.param.name == "") {
          this.loginNote = "请输入姓名"
          $this.$loading.close()
        }
        this.login_button_txt = '报名中…'

        var param = this.param
        var qs = require('qs');
        let url = this.api.userApi.hyroxSignUp
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {
          // // console.log(result)
          if (result.code == 0) {
            $this.$loading.close()
            
            $this.login_button_txt = '报名成功'
            
          } else {
            $this.$loading.close()
            $this.login_button_txt = '报名失败'
            $this.loginNote = result.msg
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
          $this.$loading.close()
          $this.login_button_txt = '报名失败'
        })
      },
     }, 
    destroyed() {
      window.removeEventListener('popstate', this.backChange, false);//false阻止默认事件
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .vlogin{
    width: 100%;
    height: 100vh;
    background: url(http://feiran-unionfit.oss-cn-beijing.aliyuncs.com/2026/03/5eyBM_2DmmXau6Brz1f9r.png) center center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    .vlogin_container{
      width:630*@vm_base;
      height:824*@vm_base;
      padding: 0 40*@vm_base;
      // background:rgba(255,255,255,0.7);
      position: relative;
      margin-top: -50*@vm_base;

      .vlogin_container_logo{
        position: absolute;
        top: 0;
        left: 0;
        width: 120*@vm_base;
        height: 120*@vm_base;
        margin-left:calc(50% - 60*@vm_base);
        margin-top: -60*@vm_base;
      }
      .vlogin_container_img{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left: 0;
        z-index:1;
      }
      .vlogin_container_con{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left: 0;
        z-index:2;
        padding: 0 40*@vm_base;
        .vlogin_container_title{
          width:100%;
          height:36*@vm_base;
          line-height: 36*@vm_base;
          font-size:36*@vm_base;
          text-align: center;
          // font-family:PingFang-SC-Bold,PingFang-SC;
          font-weight:bold;
          color:rgba(68,64,84,1);
          margin-top: 100*@vm_base;
        }
        .vlogin_container_tips{
          width:100%;
          height:26*@vm_base;
          line-height:26*@vm_base;
          font-size:26*@vm_base;
          // font-family:RTWSYueGoTrial-Regular,RTWSYueGoTrial;
          font-weight:400;
          color:rgba(143,140,152,1);
          text-align: center;
          margin-top: 16*@vm_base;
          margin-bottom: 80*@vm_base;
        }
        .login_item{
          background: #FFFFFF;
          border-radius:12*@vm_base;
          width: 100%;
          height: 90*@vm_base;
          padding: 25*@vm_base 0;
          margin-bottom: 20*@vm_base;
          .login_item_area{
            text-align: center;
            border-right:1*@vm_base solid rgba(153,153,153,1);
          }
          .login_item_date{
            width: 100%;
            padding-left: 10*@vm_base;
            position: relative;
            input{
              width: 100%;
            }
            span{
              display: inline-block;
              position: absolute;
              top: 0;
              right: 0;
              margin-right: 10*@vm_base;
              width: 40*@vm_base;
              height: 40*@vm_base;
              z-index: 3;
              background:url(../../assets/images/base/icon_clear.png) center center no-repeat;
              background-size:30*@vm_base auto;
            }
          }

        }
        .login_itemcode{
          background: #FFFFFF;
          border-radius:12*@vm_base;
          width: 100%;
          height: 90*@vm_base;
          padding: 25*@vm_base;
          .getcode{
            text-align: right;
            white-space: nowrap;
          }
        }
        .login_item_submit{
          width:100%;
          height:90*@vm_base;
          position: relative;
          margin-top: 40*@vm_base;


          .login_item_submit_bg{
            width:100%;
            height:90*@vm_base;
            background:rgba(68,64,84,1);
            border-radius:12*@vm_base;
            opacity:0.79;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }
          .login_item_submit_txt{
            width:100%;
            height:90*@vm_base;
            line-height: 90*@vm_base;
            text-align: center;
            font-size:32*@vm_base;
            // font-family:PingFang-SC-Medium,PingFang-SC;
            font-weight:500;
            color:rgba(255,255,255,1);
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            // line-height:36px;
          }
        }
        .login_item_tip{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          text-align: center;
          margin-bottom: 32*@vm_base;
          color: #575A6A;
          font-size: 24*@vm_base;
        }
        // .login__item{
        //   border: 1px solid red;
        // 	width: 100%;
        //   height: 90*@vm_base;
        //   padding: 25*@vm_base 0;
        // }
      }

    }
  }
  .bb_vlogin_container_tip{
    position: absolute;
    bottom: 0;
    left: 0;
    margin-bottom: -100*@vm_base;
    width: 100%;
    color: #FFFFFF;
    font-size: 24*@vm_base;
    text-align: center;
    div{
      display: inline-block;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hyrox/hyrox.vue